import React from "react";
import { useLanguageBooks } from "../_hooks/useLanguageBooks";
import { useSelector } from "react-redux";
import { useTranslation } from "../../../contexts/I18nProvider";
import LanguageCheckboxes from "./form-items/language-checkboxes";
import LanguageSearchInput from "./form-items/language-search-input";
import QuickFilterPills from "./quick-filter-pills";
import ActiveLanguages from "./active-languages";
import MiscallenousBar from "./miscallenous-bar";
import {
  selectFilteredLanguages,
  selectLanguagesData,
  selectPurchasedLanguages,
} from "../../../redux/selectors/languageSelectors";
import { selectQuickFilter } from "../../../redux/selectors/filterSelectors";

function DesktopFilterToolbar() {
  const { t } = useTranslation();
  useLanguageBooks(); // Fetch languages and books
  const languages = useSelector(selectLanguagesData);
  const filteredLanguages = useSelector(selectFilteredLanguages);
  const purchasedLanguages = useSelector(selectPurchasedLanguages);
  const quickFilter = useSelector(selectQuickFilter);

  const languageHeader =
    quickFilter === "audio"
      ? t('polyglot.languagesWithAudio')
      : quickFilter === "purchased"
        ? t('polyglot.purchasedLanguages')
        : quickFilter === "recent"
          ? t('polyglot.recentLanguages')
          : t('polyglot.africanLanguages');

  return (
    <div className="w-full lg:mt-2 hidden lg:flex flex-col rounded-2xl space-y-4 p-5 overflow-x-clip polyglot-sidebar-card bg-white/95 border border-border/40 shadow-sm">
      <div className="space-y-4 w-full">
        <LanguageSearchInput />

        <QuickFilterPills />

        <ActiveLanguages />

        <div className="flex items-center justify-between text-xs uppercase tracking-wide text-muted-foreground">
          <span>{languageHeader}</span>
          <span>
            (
            {quickFilter === "purchased"
              ? purchasedLanguages.length
              : filteredLanguages.length || languages.length}
            )
          </span>
        </div>

        <LanguageCheckboxes />

        <MiscallenousBar />
      </div>
    </div>
  );
}

export default DesktopFilterToolbar;
